import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import ReactLoading from 'react-loading'
import { deleteUser, closeDeleteUserModal } from 'redux/actions/users'

const DeleteModal = ({ isOpen, closeModal, user, deleteUser, isLoading, source, history }) => !user ? null : (
  <Modal isOpen={isOpen} fade={false} toggle={closeModal} className="warning">
    <ModalHeader toggle={closeModal}>Eliminar Usuario</ModalHeader>
    <ModalBody>
      Estás seguro de que quieres borrar a {user.name} ?
    </ModalBody>
    <ModalFooter>
      <Button disabled={isLoading} color="warning" className="mr-1" onClick={() => deleteUser({user, source, history})}>
        {isLoading && <ReactLoading type="spinningBubbles" color="#fff" height={10} width={10} className="d-inline-block mr-4 ml-2" />}
        Eliminar
      </Button>
      <Button disabled={isLoading} color="primary" onClick={closeModal}>Cancelar</Button>
    </ModalFooter>
  </Modal>
)

DeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  user: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  source: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
}

const mapStateToProps = ({ users: { source, openedDeleteUserModal, selectedUser, deletingUser } }) => ({
  isOpen: openedDeleteUserModal,
  user: selectedUser,
  isLoading: deletingUser,
  source
})

const mapDispatchToProps = dispatch => ({
  deleteUser: info => dispatch(deleteUser(info)),
  closeModal: () => dispatch(closeDeleteUserModal()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteModal))
